import React, { useEffect } from 'react';
import { useState } from 'react';

import { faFileLines, faFile, faFilePdf, faFileExcel, faFileWord, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Divider, Spin, message } from 'antd';

import AllegatoPreview from '../CRM/AllegatoPreview';
import sessionManager, { eVariableType } from '../SessionManager';
import { GetErrorMessage } from '../Utility';
import api from '../api';

type AllegatoMagazzinoProps = {
    codCliente: string;
    numeroBlocco: number;
    numeroBloccoFornitore: string;
    monolama: string;
};

export default function AllegatoMagazzino(props: AllegatoMagazzinoProps) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [idAllegato, setidAllegato] = useState(null);
    const [nomeFile, setNomeFile] = useState('');

    const closeModal = () => {
        setModalOpen(false);
        setidAllegato(null);
    };

    useEffect(() => {
        fetch();
    }, []);

    async function fetch() {
        try {
            setLoading(true);
            let sWhere = '';
            if (props.numeroBlocco !== null) sWhere = '&numeroBlocco=' + props.numeroBlocco;
            if (props.numeroBloccoFornitore !== null) sWhere = '&numeroBloccoFornitore=' + props.numeroBloccoFornitore;
            if (props.monolama) sWhere = sWhere + '&monolama=' + props.monolama;
            const result = await api.get(
                'Magazzino/AllegatiCarico?idSocieta=' + sessionManager.get(eVariableType.IDSocieta) + sWhere
            );

            if (result != null && result.data != null) {
                setData(result.data);
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setLoading(false);
        }
    }

    function getImageByFileType(filename: string) {
        const fileExtension: string | undefined = filename?.split('.').pop();

        switch (fileExtension?.toUpperCase()) {
            case 'TXT':
                return <FontAwesomeIcon size="3x" icon={faFileLines} />;
            case 'DOC':
            case 'DOCX':
                return <FontAwesomeIcon size="3x" icon={faFileWord} />;
            case 'XLS':
            case 'XLSX':
                return <FontAwesomeIcon size="3x" icon={faFileExcel} />;
            case 'PDF':
                return <FontAwesomeIcon size="3x" icon={faFilePdf} />;
            case 'PNG':
            case 'JPG':
            case 'JPEG':
            case 'BMP':
            case 'GIF':
                return <FontAwesomeIcon size="3x" icon={faImage} />;
            default:
                return <FontAwesomeIcon size="3x" icon={faFile} />;
        }
    }

    async function openFile(e) {
        try {
            setidAllegato(e.idAllegato);
            setNomeFile(e.nomeFileOrigine);
            setModalOpen(true);
        } catch (error) {
            message.error(error.response.data.message);
        }
    }

    return (
        <div>
            <Spin spinning={loading}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {data?.map((item: any) => (
                        <Card key={item?.idAllegato} style={{ marginRight: '1px' }} title="Documenti di carico">
                            <Button
                                className="link-button"
                                style={{ width: '25px', height: '25px', border: 'none' }}
                                onClick={() => openFile(item)}
                            >
                                {item.nomeFileOrigine}
                            </Button>
                        </Card>
                    ))}
                </div>

                {idAllegato && (
                    <AllegatoPreview
                        Open={modalOpen}
                        onClose={closeModal}
                        idAllegato={idAllegato}
                        idSocieta={Number(sessionManager.get(eVariableType.IDSocieta))}
                        nomeFile={nomeFile}
                        idDocumento={null}
                    />
                )}
            </Spin>
        </div>
    );
}
